import { Feature, IContentAPIFeature } from "./Feature";
import { GroupBase, IContentAPIGroupBase } from "./GroupBase";

export class FeatureGroupFactory {
    static create(featureGroup: IFeatureGroup | V2.IFeatureGroup): IContentAPIGroupBase {
        return new FeatureGroup(featureGroup).serialize();
    }
}

export class FeatureGroup extends GroupBase {
    protected _features?: Array<Feature>;
    protected _featureGroups?: Array<FeatureGroup>;
    protected _toggles?: boolean;

    constructor(featureGroup: IFeatureGroup | V2.IFeatureGroup) {
        super(featureGroup);

        this._features = featureGroup.features?.map((feature: IFeature | V2.IFeature) => new Feature(feature));
        this._featureGroups = featureGroup.featureGroups?.map((featureGroup: IFeatureGroup | V2.IFeatureGroup) => new FeatureGroup(featureGroup));
        this._toggles = featureGroup.toggles;
    }

    get features(): Array<Feature> | undefined {
        return this._features;
    }

    get featureGroups(): Array<FeatureGroup> | undefined {
        return this._featureGroups;
    }

    get toggles(): boolean | undefined {
        return this._toggles;
    }

    serialize(): IContentAPIFeatureGroup {
        const featureGroup: IContentAPIFeatureGroup = {
            ...super.serialize()
        };

        if (this._features !== undefined) {
            featureGroup.features = this._features.map((feature: Feature) => feature.serialize());
        }

        if (this._featureGroups !== undefined) {
            featureGroup.featureGroups = this._featureGroups.map((featureGroup: FeatureGroup) => featureGroup.serialize());
        }

        if (this._toggles !== undefined) {
            featureGroup.toggles = this._toggles;
        }

        return featureGroup;
    }
}

export interface IContentAPIFeatureGroup extends IContentAPIGroupBase {
    features?: Array<IContentAPIFeature>;
    featureGroups?: Array<IContentAPIFeatureGroup>;
    toggles?: boolean;
}